module.exports = __webpack_public_path__ + "9835e0e0e74b8d3f89dcb6b7c04f236c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/assets/phone_app.jpg
// module id = 2862
// module chunks = 0